import React from "react";
import { IconPlus } from "@tabler/icons-react";
import Button from "components/Button";
import { observer } from "mobx-react-lite";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router";
import { searchStore } from "features/ProductSearch/SearchStore";
import { ROUTES_ENUM } from "routes/consts";
import { COEStore } from "features/ComponentEditor/ComponentEditorStore";
import useComponentActions from "../tabs/useComponentActions";

function EmptyStateButtons({
  enableProductEditorCreation,
}: {
  enableProductEditorCreation: boolean;
}) {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { saveStateAndGetPath } = useComponentActions();

  const openComponentEditor = () => navigate(`${ROUTES_ENUM.COMPONENT_EDITOR}`);

  const redirectToCreateProduct = () => {
    const pathname = saveStateAndGetPath();
    navigate(`${pathname}/${ROUTES_ENUM.PRODUCT_EDITOR}`);
  };

  if (
    COEStore.openedSearchInCE &&
    searchStore.selectedTab?.type === "COMPONENT"
  )
    return <></>;
  return (
    <div className="mt-4 flex gap-4">
      {searchStore.selectedTab?.type === "PRODUCT" && (
        <Button
          width="fit-content"
          type="primary"
          leadingIcon={<IconPlus />}
          onClick={redirectToCreateProduct}
        >
          {t("mapping.createBuildingProduct")}
        </Button>
      )}
      {searchStore.selectedTab?.type === "COMPONENT" && (
        <Button
          width="fit-content"
          type="primary"
          leadingIcon={<IconPlus />}
          onClick={openComponentEditor}
        >
          {t("mapping.createComponent")}
        </Button>
      )}
      {enableProductEditorCreation ? (
        <Button
          width="fit-content"
          type="secondary"
          leadingIcon={<IconPlus />}
          onClick={redirectToCreateProduct}
        >
          {t("mapping.createBuildingProduct")}
        </Button>
      ) : null}
    </div>
  );
}

export default observer(EmptyStateButtons);
